import { AccountEvents, AccountSwitchCompletedPayload } from '@goto/shell'
import { LaunchDarklyPayload } from '../models/feature-flag.models'
import { getValueFromLocalStorage, onWindowUnload, reloadPage } from './dom-helpers'

export const getLaunchDarklyFlag = <U extends keyof T, T = LaunchDarklyPayload>(flag: U) =>
  globalThis.shell.featureFlags?.getLaunchDarklyFlag<U, T>(flag)

type Measure = { name: string; start: string | undefined; end: string | undefined }

const marks: Measure[] = [
  { name: 'init', start: undefined, end: 'goto-app init' },
  { name: 'appToShell', start: 'goto-app init', end: 'shell start' },
  { name: 'shell', start: 'shell start', end: 'shell done' },
  { name: 'shellToExperience', start: 'shell done', end: 'meetingExperience start' },
  { name: 'total', start: undefined, end: 'meetingExperience start' },
]

export const logMEPerformance = () => {
  const durations: { [key: string]: number } = {}
  try {
    // get all the measurements made so far
    performance.getEntriesByType('measure').reduce((acc, perf) => {
      acc[perf.name] = perf.duration
      return acc
    }, durations)

    marks.forEach(mark => (durations[mark.name] = measureAndDeleteMark(mark)))
    performance.clearMarks('meetingExperience start') // clear the last mark
    const [, trainingKey, attendeeKey] = location.pathname.split('/')
    const sessionTrackingId = new URLSearchParams(location.search).get('sessionTrackingId')
    window.shell.logger.log({ msg: 'ME Join Time', ...durations, trainingKey, attendeeKey, sessionTrackingId })
  } catch (error) {
    window.shell.logger.error({ msg: `Error while measuring ME performance: ${error}` })
  }
}

export const initAccountSwitch = () => {
  const { accountSwitchCompleted } = window.shell.eventBus.subscribeTo<'account', typeof AccountEvents>('account')

  const accountSwitchCompletedListener = (payload: AccountSwitchCompletedPayload) => {
    const { externalUserKey, pbxId } = payload
    const localStorageKey = `jiveweb_userSelectedDevice_${externalUserKey}`
    const localStorageSelectedUser = getValueFromLocalStorage(localStorageKey)
    // Jiveweb reloads after 100ms, we should wait a bit longer to allow for that reload to occur first
    setTimeout(() => {
      if (localStorageSelectedUser?.pbx?.id !== pbxId) {
        localStorage.removeItem(localStorageKey)
      }
      reloadPage()
    }, 150)
  }

  accountSwitchCompleted.on(accountSwitchCompletedListener)

  onWindowUnload(() => {
    accountSwitchCompleted.removeListener(accountSwitchCompletedListener)
  })
}

const measureAndDeleteMark = ({ name, start, end }: Measure) => {
  performance.measure(name, start, end)
  const [perf] = performance.getEntriesByName(name)
  // clear only the start mark, as the end mark will be used for the next measure. Do not clear if undefined, or else it will clear all marks
  if (start != undefined) performance.clearMarks(start)
  performance.clearMeasures(name)
  return perf.duration
}
